import { Injectable } from '@angular/core';
//import { DataService } from '../common/data.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';

import { DataService } from '../Common/data.service';

@Injectable({
     providedIn: 'root'
})
export class CommonService {

     constructor(private _data: DataService, private _router: Router, private http: HttpClient, private location: Location) { }

     /***********************************Method Section************************************/
     Autocomplete(url, keyword) {
          return this._data.PostData(url, { Param1: keyword, Param2: null });
     }

     BindDropDown(DropDownName) {
          return this._data.PostData('FillCommonData/GetDropdownList', { Param1: DropDownName });
     }

     BindDropDownWithParam(DropDownName, Param, Param1 = null) {
          return this._data.PostData('FillCommonData/GetDropdownList', { Param1: DropDownName, Param2: Param, Param3: Param1 });
     }

     GetAuditTrails = (id: string, className: string): any => {
          if (id != null) {
               return this._data.GetData('FillCommonData/GetAuditTrails/' + id + '/' + className);
          } else {
          }
     }

     GetNumbersList = (count) => {
          return this._data.GetData('FillCommonData/GetNumbersList/' + count);
     }

     GetAttachmentDetailByID = (ID: string): any => {
          return this._data.GetDataById('Attachment/GetAttachmentByID', ID);
     }

     UploadAttachment = (formData): any => {
          return this._data.PostData('Attachment/UploadAttachment', formData);
     }

     DeleteAttahment = (attachmentList): any => {
          return this._data.PostData('Attachment/DeleteAttachment', attachmentList);
     }
     SendMail = (data: any): any => {
          return this._data.PostData('SendMail/SendMailDetail', data);
     }
     /*******************************************Global Function**************************/
     Exit() {
          if (confirm('Are you sure to exit?')) {
               //this._router.navigate(['dashboard']);
               this.location.back();
          }
     }

     GetMultipleFilterColumns = (pageid: string): any => {
          return this._data.GetDataById('FillCommonData/GetMultipleFilterColumns', pageid);
     }
     GetFilterContainValues = (): any => {
          return this._data.GetDataById('FillCommonData/GetFilterContainValues', '');
     }

     ExportData = (data: any): any => {
          return this._data.DownloadFileWithPost('Category/ExportToExcel', data);
     }

     ExportToExcelSubCategory = (data: any): any => {
          return this._data.DownloadFileWithPost('Category/ExportToExcelSubCategory', data);
     }

     ExportToExcelItem = (data: any): any => {
          return this._data.DownloadFileWithPost('Category/ExportToExcelItem', data);
     }

     ExportToExcelAssignmentGroup = (data: any): any => {
          return this._data.DownloadFileWithPost('Category/ExportToExcelAssignmentGroup', data);
     }

     ExportToExcelMappingGroup = (data: any): any => {
          return this._data.DownloadFileWithPost('Category/ExportToExcelMappingGroup', data);
     }

     ExportToExcelEscalation = (data: any): any => {
          return this._data.DownloadFileWithPost('Category/ExportToExcelEscalation', data);
     }

     ExportToSLA = (data: any): any => {
          return this._data.DownloadFileWithPost('Category/ExportToExcelSLA', data);
     }

     ExportToExcelAssigmentUpload = (data: any): any => {
          return this._data.DownloadFileWithPost('Category/ExportToExcelAssigmentUpload', data);
     }





     /*******************************************End Function*****************************/
}


